<template>
  <div class="pipenetBody">
    <el-col>
      <el-form label-width="auto">
        <div style="display: flex; flex-direction: row">
          <div>
            <el-form-item label="所属区域：">
              <el-select
                v-model="dictValueItem"
                value-key="dictValue"
                placeholder="请选择所属区域"
                @change="regionNameChange"
                style="width: 250px; margin-right: 10px"
              >
                <el-option
                  v-for="item in this.regionNameList"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div>
            <el-form-item label="道路(小区)：">
              <el-select
                v-model="roadListItem"
                value-key="id"
                allow-create
                filterable
                placeholder="请选择道路(小区)"
                style="width: 250px; margin-right: 10px"
              >
                <el-option
                  v-for="item in this.roadList"
                  :key="item.id"
                  :label="item.roadName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div>
            <el-button type="primary" @click="querySubmit()">查询</el-button>
            <el-button @click="queryReset()">重置</el-button>
            <el-button type="primary" @click="createPipeSegments()"
              >生成管段</el-button
            >
          </div>
        </div>
      </el-form>

      <el-divider />
      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
        >
          <el-table-column
            label="序号"
            type="index"
            align="center"
            width="50"
          />
          <el-table-column
            label="道路(小区)"
            prop="roadName"
            width="200"
            align="center"
          />

          <el-table-column
            label="管井数（座）"
            prop="wellNum"
            width="200"
            align="center"
          />
          <el-table-column
            label="管道长度（米）"
            prop="pipeLength"
            width="200"
            align="center"
          />
          <el-table-column
            label="生成时间"
            prop="createTime"
            width="200"
            align="center"
          />
          <el-table-column label="操作" prop="tpye" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="jumpWell(scope.row)"
                >管井明细
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="jumpPipeNet(scope.row)"
                >管道明细
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--页码-->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryForm.current"
          :limit.sync="queryForm.size"
          @pagination="pipenetQueryPage"
        />
      </div>
    </el-col>
  </div>
</template>

<style scoped lang="scss">
.pipenetBody {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
<script>
import Pagination from '@/components/PaginationStyle1.vue';
import {
  createPipeSegments,
  getSegmentsByPageDto,
} from '@/api/pipenetmanagement';
import { getDictList } from '@/api/equipmentmanagement';
import CommonApi from '@/api/common';

export default {
  components: { Pagination },
  name: 'PipeNet',
  data() {
    return {
      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        size: 10,
        current: 1,
        townCode: '',
        roadId: '',
        roadName: '',
      },
      pipeSegmentsList: [],

      dictValueItem: {},
      roadList: [],
      roadListItem: {},
      regionNameList: [],
    };
  },
  methods: {
    async getDictList() {
      const result = await getDictList({ dictCode: 'town_code' });
      // console.log(result.data.data)
      this.regionNameList = result.data.data;
    },

    async pipenetQueryPage() {
      this.listLoading = true;
      const res = await getSegmentsByPageDto(this.queryForm);
      // console.log(res)
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },
    querySubmit() {
      this.queryForm.size = 10;
      this.queryForm.current = 1;
      this.queryForm.roadId = this.roadListItem.id;
      this.pipenetQueryPage();
    },
    queryReset() {
      this.queryForm = this.$options.data().queryForm;
      this.roadListItem = {};
      this.dictValueItem = {};
      this.pipenetQueryPage();
    },
    async createPipeSegments() {
      const result = await createPipeSegments();
      if (result.data.code === 200) {
        this.$message({ message: '生成成功', type: 'success' });

        //添加后刷新
        this.pipenetQueryPage();
      } else {
        this.$message.error(result.data.message);
      }
    },
    regionNameChange() {
      this.roadList = [];
      this.queryForm.townCode = this.dictValueItem.dictValue;
      CommonApi.queryRoadList({
        townCode: this.dictValueItem.dictValue,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;
        } else {
          this.roadList = [];
        }
      });
    },
    jumpWell(obj) {
      this.$router.push(
        '/well?townCode=' + obj.townCode + '&roadId=' + obj.roadId
      );
    },
    jumpPipeNet(obj) {
      this.$router.push(
        '/drainagepipe?townCode=' + obj.townCode + '&roadId=' + obj.roadId
      );
    },
  },
  created() {
    this.getDictList();
    this.pipenetQueryPage();
  },
};
</script>
